import React from "react";
import PageShell from "../common/page_shell";
import Aboutme from "../inner/aboutme/about_me";
import data from "../data/biodata.json";

const AboutPage = () => {
  return (
    <PageShell>
      <Aboutme
        content={data?.details?.about_me || {}}
        services={data?.details?.services || []}
      />
    </PageShell>
  );
};

export default AboutPage;
